import {Injectable} from '@angular/core';
import {EventDispatcherService} from './event-dispatcher.service';

@Injectable()
export class DynamicFormEventsService {

    public onSubmit = this.eventDispatcher.onControlClick.asObservable();

    public onControlClick = this.eventDispatcher.onControlClick.asObservable();
    public onControlBlur = this.eventDispatcher.onControlBlur.asObservable();

    public onControlSuffixClick = this.eventDispatcher.onControlSuffixClick.asObservable();

    public onControlPrefixClick = this.eventDispatcher.onControlPrefixClick.asObservable();

    /**
     * The validation status of the control. There are four possible validation status values:
     * VALID: This control has passed all validation checks.
     * INVALID: This control has failed at least one validation check.
     * PENDING: This control is in the midst of conducting a validation check.
     * DISABLED: This control is exempt from validation checks.
     */
    public onFieldStatusChanged = this.eventDispatcher.onFieldStatusChanged.asObservable();

    public onFieldValueChanged = this.eventDispatcher.onFieldValueChanged.asObservable();

    constructor(
        private readonly eventDispatcher: EventDispatcherService
    ) {
    }
}
